<template>
  <div>
    <connect-icon />
    <h5 class="text-center">{{ $t("imports.connectSchoology") }}</h5>
    <p class="text-center">
      By connecting to Schoology, EssayGrader can automatically import student
      assignments for grading and export feedback directly back to Schoology —
      no manual uploads or downloads needed.
    </p>
    <eg-b-alert show variant="secondary">
      <div>{{ $t("imports.dontForget") }}</div>
      {{ $t("imports.noChangesToSchoology") }}
    </eg-b-alert>
  </div>
</template>

<script>
import ConnectIcon from "../icons/connect-icon.vue";

export default {
  components: { ConnectIcon },
};
</script>
